export default "__VITE_ASSET__CVLpV$Zy__"